/**
 * 全局配置
 */
export const globalConfig = {
  lang: 'zh'
};
